<template>
  <div>
    <signature-hub
      :can-cancel-document="canCancelDocument"
      :can-sign-document="canSignDocument"
      :cancel-document="cancelDocument"
      :get-sign-document-url="getSignDocumentUrl"
      :participants="participants"
      :print-action-text="getNameButtonPrint"
      :related-id="relatedId"
      :resend-invitation="resendInvitation"
      :save-signature-hub="saveSignatureHub"
      :search-user-email="searchUserEmail"
      :send-document="sendDocument"
      :signature-hub-info="signatureHubInfo"
      :type-id="typeId"
      :user-profile-info="userProfileInfo"
      @document-cancelled="handleDocumentCancelled"
      @go-back="handleGoBack"
      @print="handlePrint"
      @saved="handleSaved"
      @sign-document-closed="handleSignDocumentClosed"
      @update-signature="handleUpdateSignature"
    />
  </div>
</template>

<script>
// libs
import { SignatureHub } from '@quisit/signature-hub';

// services
import {
  searchUserEmail as _searchUserEmail,
  saveSignatureHub as _saveSignatureHub,
  getSignatureHubInfo as _getSignatureHubInfo,
  sendDocument as _sendDocument,
  resendInvitation as _resendInvitation,
  cancelDocument as _cancelDocument,
  getSignedDocument as _getSignedDocument,
  getSignDocumentUrl as _getSignDocumentUrl,
} from '@/modules/signatureHub/api.js';
import _generalApi from '@/modules/app/api';
import signatureHubTypes from '@/utils/constants/signatureHubTypes.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'MainSignatureHub',
  components: {
    SignatureHub,
  },
  mixins: [alertMixin],
  data() {
    return {
      participants: [],
      signatureHubInfo: null,
      from: 'signature-hub',
      fromData: {
        tabModel: 1,
      },
      query: null,
    };
  },
  computed: {
    getNameButtonPrint() {
      if (this.typeId === signatureHubTypes.INTERVENTION_PLAN) {
        return 'Imprimir Plan';
      }
      if (this.typeId === signatureHubTypes.ADMISSION_NOTE) {
        return 'Imprimir Nota de Admisión';
      }
      if (this.typeId === signatureHubTypes.INTERVENTION_PLAN_PERIOD) {
        return 'Imprimir Informe de Logros';
      }
      return 'Imprimir';
    },
    typeId() {
      return this.$route.params.typeId;
    },
    canCancelDocument() {
      return this.signatureHubInfo?.canCancelDocument;
    },
    relatedId() {
      return `${this.$route.params.relatedId}`;
    },
    userProfileInfo() {
      return {
        userId: this.userProfile.sub,
        userName: this.userProfile.name,
        name: this.userProfile.givenname,
        email: this.userProfile.email,
      };
    },
    canSignDocument() {
      return [signatureHubTypes.REFUND_CERTIFICATION_REQUEST].includes(
        Number(this.typeId)
      );
    },
  },
  async mounted() {
    if (this.$route.params.from) {
      this.from = this.$route.params.from;
      this.fromData = this.$route.params.fromData;
      this.query = this.$route.query;
    }
    await this.fetchSignatureHubInfo();
  },
  methods: {
    handleGoBack() {
      this.$router.push({
        name: this.from,
        params: this.fromData,
        query: this.query,
      });
    },
    async handleSaved() {
      await this.fetchSignatureHubInfo();
    },
    async handleDocumentCancelled() {
      await this.fetchSignatureHubInfo();
    },
    async handleUpdateSignature() {
      await this.fetchSignatureHubInfo();
    },
    async handlePrint({ typeId, relatedId, documentId }) {
      if ((typeId, relatedId, documentId)) {
        const response = await _getSignedDocument(
          typeId,
          relatedId,
          documentId
        ).catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
        if (response?.data) {
          _generalApi.ConvertToBlob(response.data);
        }
      }
    },
    async fetchSignatureHubInfo() {
      const response = await _getSignatureHubInfo(this.typeId, this.relatedId);
      if (response?.data) {
        const participants = Array.isArray(response.data.participants)
          ? response.data.participants
          : [];

        const mappedParticipants = participants.map((participant) => ({
          ...participant,
          selectedOther:
            (participant?.accounts?.length &&
            !participant?.accounts?.some((a) => a.email === participant.email)
              ? 1
              : null) || !participant.accounts?.length,
          searchEmailSnapshot: {
            input: participant.email,
            data: [],
          },
          userAccount: null,
        }));

        this.participants = mappedParticipants;

        this.signatureHubInfo = {
          ...response.data,
          participants: mappedParticipants,
        };
      }
    },
    isResetSignatureHubInfo() {
      return (
        !this.signatureHubInfo?.signatureHubId &&
        !this.signatureHubInfo?.documentId
      );
    },
    searchUserEmail(params) {
      return _searchUserEmail(params);
    },
    saveSignatureHub(payload) {
      return _saveSignatureHub(payload);
    },
    sendDocument(typeId, relatedId) {
      return _sendDocument(typeId, relatedId);
    },
    resendInvitation(payload) {
      return _resendInvitation(payload);
    },
    cancelDocument(typeId, relatedId, payload) {
      return _cancelDocument(typeId, relatedId, payload);
    },
    getSignDocumentUrl(typeId, relatedId) {
      return _getSignDocumentUrl(typeId, relatedId);
    },
    async handleSignDocumentClosed() {
      const hadDocumentBeforeClose = Boolean(this.signatureHubInfo?.documentId);

      await this.fetchSignatureHubInfo();

      if (hadDocumentBeforeClose && this.isResetSignatureHubInfo()) {
        await this.fetchSignatureHubInfo();
      }
    },
  },
};
</script>
